import React, { SVGProps } from 'react';

export const ChipSVG = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M3.125 6.875H5.625M3.125 10H5.625M3.125 13.125H5.625M14.375 6.875H16.875M14.375 10H16.875M14.375 13.125H16.875M8.125 3.125V0.625M11.875 3.125V0.625M8.125 19.375V16.875M11.875 19.375V16.875M6.875 3.125H13.125C13.8154 3.125 14.375 3.68464 14.375 4.375V15.625C14.375 16.3154 13.8154 16.875 13.125 16.875H6.875C6.18464 16.875 5.625 16.3154 5.625 15.625V4.375C5.625 3.68464 6.18464 3.125 6.875 3.125Z'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
